// extracted by mini-css-extract-plugin
export default {"atcText":"PowerTransformer_atcText__BDnXN"};